import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { usePageTitle } from "@/lib/content";
import { Reveal } from "@/components/site/Reveal";
import { GUIDES } from "@/lib/guides";

export default function GuidesHub() {
  usePageTitle(
    "Construction, FIFO & Mining Job Seeker Guides | Sitebound",
    "Free Australian guides for construction, civil, mining and FIFO job seekers — getting started, resumes, tickets and licences, FIFO work and interview preparation."
  );

  return (
    <div data-testid="guides-hub" className="mx-auto max-w-7xl px-4 py-16 sm:px-6 md:py-24 lg:px-8">
      <Reveal>
        <div className="mono-label">Free resources</div>
        <h1 className="font-display mt-4 max-w-4xl text-4xl font-extrabold uppercase leading-[0.95] tracking-tight text-slate-100 sm:text-5xl lg:text-6xl">
          Construction, FIFO &amp; Mining Job Seeker Guides
        </h1>
        <p className="mt-6 max-w-2xl text-base leading-relaxed text-slate-400">
          Practical, Australian-specific guides for people trying to break into construction, civil,
          mining and FIFO work. Free to read. Written from real industry experience — no fluff, no
          recycled corporate advice.
        </p>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 gap-px bg-white/10 md:grid-cols-2 lg:grid-cols-3">
        {GUIDES.map((g, i) => (
          <Reveal key={g.slug} delay={i * 0.05}>
            <Link
              to={`/guides/${g.slug}`}
              data-testid={`guide-card-${g.slug}`}
              className="group flex h-full flex-col bg-[#0D0F12] p-8 transition-colors hover:bg-[#121418]"
            >
              <span className="mono-label">{g.category}</span>
              <h2 className="font-display mt-4 text-xl font-bold uppercase leading-tight tracking-tight text-slate-100 transition-colors group-hover:text-[#FF5500]">
                {g.h1}
              </h2>
              <p className="mt-3 flex-1 text-sm leading-relaxed text-slate-400">{g.description}</p>
              <span className="mt-6 flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-[#FF5500]">
                Read guide <ArrowRight className="h-3.5 w-3.5 transition-transform group-hover:translate-x-1" />
              </span>
            </Link>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.1}>
        <div className="mt-16 border border-white/10 bg-[#0D0F12] p-8 sm:p-10">
          <div className="mono-label">Go further</div>
          <p className="mt-4 max-w-2xl text-sm leading-relaxed text-slate-300">
            These guides cover the approach. The Sitebound Complete Construction Job Seeker Pack adds
            the tools: editable resume and cover letter templates, interview frameworks, ticket
            roadmaps, FIFO preparation and job-search checklists — 95 resources in one download.
          </p>
          <div className="mt-6 flex flex-wrap gap-4">
            <Link
              data-testid="guides-cta-pack"
              to="/product/complete-construction-job-seeker-pack"
              className="bg-[#FF5500] px-6 py-3 text-xs font-bold uppercase tracking-widest text-white transition-colors hover:bg-[#E04800]"
            >
              See the Complete Pack — $49 AUD
            </Link>
            <Link
              data-testid="guides-cta-shop"
              to="/shop"
              className="border border-white/25 px-6 py-3 text-xs font-bold uppercase tracking-widest text-slate-100 transition-colors hover:border-[#FF5500] hover:text-[#FF5500]"
            >
              Browse the shop
            </Link>
          </div>
        </div>
      </Reveal>
    </div>
  );
}
